function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { delay } from 'lodash';
import Cookies from 'cookies-js';
import withMainControls from 'eventbrite_design_system/structure/hoc/withMainControls';
import { TYPE_ERROR } from 'eventbrite_design_system/notification/constants';
import { EVENT_COOKIE, EVENT_SAVE, EVENT_SAVE_ERROR } from '../constants';
import AlertChunkySvg from 'eventbrite_design_system/iconography/icons/AlertChunky';
import CheckChunkySvg from 'eventbrite_design_system/iconography/icons/CheckChunky';
/*
This is an HoC that should be utilized with applications that implement
save/unsave functionality for events. It should be wrapped at a high level
such that isAuthenticated and an onSave can be passed as props.

In the case of a logged out save and then follow up redirect back, it will
parse the cookie and attempt to call the passed in save action and then display
a notification that the event was successfully saved.

Additionally it passed down a prop to display an already configured success or
error notification for the event save action.
*/

var withEventSaveNotification = function withEventSaveNotification(Component) {
  var _class, _temp;

  return withMainControls((_temp = _class =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inheritsLoose(LoggedOutEventSaveRedirect, _React$PureComponent);

    function LoggedOutEventSaveRedirect() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_this), "_handleShowSaveNotification", function (status, isRedirect) {
        if (isRedirect === void 0) {
          isRedirect = false;
        }

        var _this$props = _this.props,
            addMainNotification = _this$props.addMainNotification,
            hideMainNotification = _this$props.hideMainNotification;
        var notificationInfo = {
          type: TYPE_ERROR,
          children: EVENT_SAVE_ERROR,
          iconType: React.createElement(AlertChunkySvg, null),
          isNotificationSticky: true
        };

        if (status === 'success') {
          notificationInfo = {
            children: EVENT_SAVE,
            iconType: React.createElement(CheckChunkySvg, null),
            isNotificationSticky: true
          };
        } //Only show notification if an error, or user save
        //was successful after log-in redirect


        if (status !== 'success' || status === 'success' && isRedirect) {
          addMainNotification(notificationInfo);
          delay(hideMainNotification, 7000);
        }
      });

      return _this;
    }

    var _proto = LoggedOutEventSaveRedirect.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          isAuthenticated = _this$props2.isAuthenticated,
          onSaveEvent = _this$props2.onSaveEvent;
      var eventIdFromCookie = Cookies.get(EVENT_COOKIE);

      if (eventIdFromCookie && isAuthenticated) {
        onSaveEvent(eventIdFromCookie, true, {}, false).then(function (status) {
          _this2._handleShowSaveNotification(status, true);
        }).catch(function () {
          _this2._handleShowSaveNotification('error', true);
        });
        Cookies.expire(EVENT_COOKIE);
      }
    }
    /*
    @param status {string} oneOf(['success', 'error'])
    @param isRedirect {bool}
    */
    ;

    _proto.render = function render() {
      return React.createElement(Component, this.props);
    };

    return LoggedOutEventSaveRedirect;
  }(React.PureComponent), _defineProperty(_class, "propTypes", {
    /*
    Function that will be called if user is redirected back
    and we need to trigger the save action
    */
    onSaveEvent: PropTypes.func.isRequired,

    /*
    Needed to determine if possible to call save event
    callback
    */
    isAuthenticated: PropTypes.bool.isRequired
  }), _temp));
};

export default withEventSaveNotification;